// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"632":"510dc90e","684":"cd98e07a","745":"951056b5","814":"d6fda674","846":"ad5a2e78","906":"9afd2934","922":"1dbeda51","940":"cc2ddf06"}[chunkId] + ".js";
};